import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

export const Route = createFileRoute("/en/privacy-policy")({
  head: () => buildRouteHead("/en/privacy-policy"),
  component: PrivacyPolicy,
});

